import { render, staticRenderFns } from "./ReceiverGroup.vue?vue&type=template&id=7238b2fc&"
import script from "./ReceiverGroup.vue?vue&type=script&lang=ts&"
export * from "./ReceiverGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiverGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports